import cards from './cards';

export default {
  namespaced: true,
  modules: {
    cards
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/payment/index.js